import React from 'react';
import { Column, Row, Stack } from '@grubhubprod/gh-cookbook-react';
import { PageSectionTitle } from 'src/components/enterprise/layout/PageSectionTitle/PageSectionTitle';
import { TransactionFeeField } from 'src/components/enterprise/features/Corporate/components/Form/TransactionFeeField/TransactionFeeField';
import { TermSelect } from 'src/components/enterprise/features/Corporate/components/Form/TermSelect/TermSelect';
import { InvoicePaymentWrapper } from 'src/components/enterprise/features/Corporate/components/Form/InvoicePaymentWrapper/InvoicePaymentWrapper';
import { ReportingRequirementWrapper } from 'src/components/enterprise/features/Corporate/components/Form/ReportingRequirementWrapper/ReportingRequirementWrapper';
import { InvoicingMethodWrapper } from 'src/components/enterprise/features/Corporate/components/Form/InvoicingMethodWrapper/InvoicingMethodWrapper';
import { OptionalReportingWrapper } from 'src/components/enterprise/features/Corporate/components/Form/OptionalReportingWrapper/OptionalReportingWrapper';
import { BulkUploadEmployeeWrapper } from 'src/components/enterprise/features/Corporate/components/Form/BulkUploadEmployeeWrapper/BulkUploadEmployeeWrapper';
import { CateringServiceFeeControl } from 'src/components/enterprise/features/Corporate/components/Form/CateringServiceFeeControl/CateringServiceFeeControl';
import { AutoInvoicingWrapper } from 'src/components/enterprise/features/Corporate/components/Form/AutoInvoicingWrapper/AutoInvoicingWrapper';
import { IntacctStatus } from 'src/components/enterprise/features/Corporate/components/Form/IntacctStatus/IntacctStatus';
import { InvoicingPeriodControl } from 'src/components/enterprise/features/Corporate/components/Form/InvoicingPeriodControl/InvoicingPeriodControl';
import PageSection from 'src/components/enterprise/layout/PageSection';

export const InvoiceInformationSection: React.FC = () => {
  return (
    <Stack y="md">
      <PageSection>
        <Row>
          <Column phone={10}>
            <Stack y="sm">
              <PageSectionTitle title="Invoice Information" />
            </Stack>
            <Row gutter={12}>
              <Column phone={6} gutter={12}>
                <Stack y="sm">
                  <TransactionFeeField
                    name="firmTransactionFee"
                    id="firmTransactionFee"
                  />
                </Stack>
              </Column>
              <Column phone={6} gutter={12}>
                <Stack y="sm">
                  <TermSelect name="intacctTermName" id="intacctTermName" />
                </Stack>
              </Column>
            </Row>
            <Row gutter={12}>
              <AutoInvoicingWrapper />
              <IntacctStatus />
            </Row>
            <Row gutter={12}>
              <Column phone={4} gutter={12}>
                <InvoicingPeriodControl name="invoiceRrule" id="invoiceRrule" />
              </Column>
            </Row>
            <Row gutter={12}>
              <Column phone={12} gutter={12}>
                <Stack y="sm">
                  <InvoicePaymentWrapper />
                </Stack>
              </Column>
            </Row>
            <Row gutter={12}>
              <Column phone={4} gutter={12}>
                <Stack y="sm">
                  <ReportingRequirementWrapper />
                </Stack>
              </Column>
              <Column phone={4} gutter={12}>
                <Stack y="sm">
                  <InvoicingMethodWrapper />
                </Stack>
              </Column>
            </Row>
            <Row gutter={12}>
              <Column phone={6} gutter={12}>
                <Stack y="sm">
                  <CateringServiceFeeControl
                    name="cateringServiceFee"
                    id="cateringServiceFee"
                  />
                </Stack>
              </Column>
            </Row>
            <Row gutter={12}>
              <Column phone={4} gutter={12}>
                <OptionalReportingWrapper />
              </Column>
              <Column phone={4} gutter={12}>
                <BulkUploadEmployeeWrapper />
              </Column>
            </Row>
          </Column>
        </Row>
      </PageSection>
    </Stack>
  );
};
